import React from 'react'
import ReactTooltip from 'react-tooltip'
import { ReactComponent as CommentIcon } from '../../assets/svg/CommentIcon.svg'
import { emotions_color, emotions_color_opacity_03, emotions_color_dark, emotions_heads } from '../../constants/Constants'

// Cards past this index all share the same entrance delay so a large class
// never makes the user wait for the tail of the stagger.
const STAGGER_CAP = 12

export const COMMENT_TOOLTIP_ID = 'classroom-comment-tip'

/**
 * The one tooltip instance shared by every card on the screen. Mount it once
 * (in the page container). Lists call `ReactTooltip.rebuild()` after their
 * cards mount so late-mounted cards (virtualization, expand) get bound too.
 */
export const CommentTooltip = () => (
    <ReactTooltip
        id={COMMENT_TOOLTIP_ID}
        backgroundColor="#FAFAFF"
        arrowColor="#FAFAFF"
        border={true}
        borderColor="#BEBECE"
        place="top"
        effect="solid"
        className="classroom-tooltip"
    />
)

/**
 * One person (student or teacher) with their "How are you today?" answer.
 * Memoized: lists re-render on every keystroke of the search box, but the
 * `student` objects themselves are reused by the filters, so unchanged cards
 * bail out here.
 */
function StudentCard({ student, index = 0, onSelect }) {
    const emotion = student?.feedback?.emotion
    const message = student?.feedback?.message

    return (
        <div
            className="classroom-wellbeing-student classroom-card"
            id={`classroom-student-${student?.user?.id}`}
            style={{
                border: `1px solid ${emotions_color[emotion]}`,
                background: emotions_color_opacity_03[emotion],
                '--i': Math.min(index, STAGGER_CAP),
            }}
            onClick={() => onSelect(student)}
        >
            <img src={emotions_heads[emotion]} alt="emotion" width={48} height={48} />
            <p>
                {student?.user?.first_name} {student?.user?.last_name}
            </p>
            {message && (
                <i className="classroom-card-comment" data-tip={message} data-for={COMMENT_TOOLTIP_ID}>
                    <CommentIcon style={{ color: emotions_color_dark[emotion] }} />
                </i>
            )}
        </div>
    )
}

export default React.memo(StudentCard)
